export default function arrayCompare(arrayA, arrayB) {

    const strArrA = arrayA.slice().sort().join(",");
    const strArrB = arrayB.slice().sort().join(",");
    
    // console.log("A vs. B", strArrA, strArrB, strArrA === strArrB);
    return strArrA === strArrB;
}